import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { AppRemixIcon } from '@/layout/AppComponents';
import colors from '../../../../../constants/colors';
import { axiosPath, path } from '../../../../../routing/helpers/router';
import {
  getTotalEnergiesRiskActionPlanFilterInitialValues,
  getTotalEnergiesRiskControlFilterInitialValues,
} from '../../../../../minions/forms';

const NavBarTotalEnergiesRisk = () => {
  const { moduleBridgeHex } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const filterPermissions = useSelector(
    (state) =>
      state.module[moduleBridgeHex]?.permissions?.gcl?.module?.plant?.filters,
  );
  const [navbarInfo, setNavbarInfo] = useState();

  // > GET NARVBAR INFO
  const getNavbarInfo = async () => {
    try {
      const response = await axios.post(
        axiosPath('api_r_user_module_totalEnergiesRisk_getNavbarInfo'),
        { moduleBridgeHex },
      );
      setNavbarInfo(response.data);
    } catch (err) {}
  };

  useEffect(() => {
    getNavbarInfo();
  }, []);
  // < GET NARVBAR INFO

  // > GENERATE FILTER HEX CODE
  const generateControlFilterHexCode = async (values) => {
    const filters = {
      ...getTotalEnergiesRiskControlFilterInitialValues(filterPermissions),
      ...values,
    };

    try {
      const response = await axios.post(
        axiosPath(
          'api_r_user_module_totalEnergiesRisk_control_generateFilterHexCode',
        ),
        { moduleBridgeHex, filters },
      );

      navigate(
        path({
          name: 'user_module_totalEnergiesRisk_control_list',
          params: {
            moduleBridgeHex,
            page: 1,
            filtersHex: response.data.hexCode,
          },
        }),
      );
    } catch (err) {}
  };

  const generateActionPlanFilterHexCode = async (values) => {
    const filters = {
      ...getTotalEnergiesRiskActionPlanFilterInitialValues(filterPermissions),
      ...values,
    };

    try {
      const response = await axios.post(
        axiosPath(
          'api_r_user_module_totalEnergiesRisk_actionPlan_generateFilterHexCode',
        ),
        { moduleBridgeHex, filters },
      );

      navigate(
        path({
          name: 'user_module_totalEnergiesRisk_actionPlan_list',
          params: {
            moduleBridgeHex,
            page: 1,
            filtersHex: response.data.hexCode,
          },
        }),
      );
    } catch (err) {}
  };
  // < GENERATE FILTER HEX CODE

  const getPendingControls = () => {
    generateControlFilterHexCode({
      alertControlIDs: true,
    });
  };

  const getPendingActionPlans = () => {
    generateActionPlanFilterHexCode({
      alertActionPlanIDs: true,
    });
  };

  return (
    <Container>
      <NavbarIcon
        title="Controles pendientes"
        className={!navbarInfo?.pendingControls ? 'off' : ''}
        onClick={getPendingControls}
      >
        <AppRemixIcon
          icon="error-warning"
          size={20}
          filled={navbarInfo?.pendingControls}
          color={
            navbarInfo?.pendingControls &&
            colors.totalEnergiesRiskControlState[3]
          }
        />
        {navbarInfo?.pendingControls > 0 && (
          <>
            {navbarInfo.pendingControls > 99 ? (
              <span className="badge">+99</span>
            ) : (
              <span className="badge">{navbarInfo.pendingControls}</span>
            )}
          </>
        )}
      </NavbarIcon>
      <NavbarIcon
        title="Planes de acción pendientes"
        className={!navbarInfo?.pendingActionPlans ? 'off' : ''}
        onClick={getPendingActionPlans}
      >
        <AppRemixIcon
          icon="error-warning"
          size={20}
          filled={navbarInfo?.pendingActionPlans}
          color={navbarInfo?.pendingActionPlans && colors.modifiedObligations}
        />
        {navbarInfo?.pendingActionPlans > 0 && (
          <>
            {navbarInfo.pendingActionPlans > 99 ? (
              <span className="badge">+99</span>
            ) : (
              <span className="badge">{navbarInfo.pendingActionPlans}</span>
            )}
          </>
        )}
      </NavbarIcon>
    </Container>
  );
};

export default NavBarTotalEnergiesRisk;

const Container = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0 15px;
  color: white;
  li {
    display: inline-block;
    padding: 0 6px;
  }
  li + li {
    border-left: 2px solid ${colors.primaryLight};
  }
  li.off {
    opacity: 0.2;
  }
`;

const NavbarIcon = styled.li`
  position: relative;
  &:hover {
    cursor: pointer;
  }
  .badge {
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: #f4f6f9;
    border-radius: 100px;
    color: ${colors.primary};
    font-size: 9px;
    padding: 2px;
    width: 15px;
    height: 15px;
    text-align: center;
  }
`;
